export default __webpack_public_path__ + "static/media/calendariocolor.d62e88ea.png";